export interface HistoryByReturnData {
  clientId: string;
  entityId: string;
  clientTaxPeriodId: number;
  entityName: string;
  returnName: string;
  locationCode: string;
  returnState: string;
  returnFrequency: string;
  year: number;
  month: number;
  estimatedTaxDue: number;
  salesAndUse: number;
  salesTax: number;
  useTax: number;
  discounts: number;
  exciseAndBOTax: number;
  prepayment: number;
  prepayCredit: number;
  salesTaxCurrentMonthCarryForward: number;
  useTaxCurrentMonthCarryForward: number;
  currentMonthCarryForward: number;
  registrationNumber: string;
}
